import React, {PureComponent as Component} from 'react';
import KickImage from 'Reuseables/KickImage';
import {Container} from 'reactstrap';
import Sneakers from '../../Sneakers';

const SneakerLoading = () => (
  <div className="product-list">
    <div className="d-flex" id="product">
      <p style={{textAlign: 'center', width: '100%'}}>Tidak ada produk terkait</p>
    </div>
  </div>
)
export default class RelatedSneakers extends Component{
  render(){
    return(
      <Container fluid className="related-sneakers">
        <Container className="product-container" fluid>
          <h5 className="underline title abbey">
            <span>
              SIMILAR PRODUCTS
            </span>
          </h5>
          { this.props.isLoading ? <SneakerLoading/> : <Sneakers similarProducts={true} fetch_related={true}/>}
        </Container>
      </Container>
    )
  }
}